import { render, staticRenderFns } from "./AccessRestriction.vue?vue&type=template&id=67e27a89"
import script from "./AccessRestriction.vue?vue&type=script&lang=js"
export * from "./AccessRestriction.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports